import { createContext, useContext, useState } from 'react'

const SidebarContext = createContext()

export function SidebarProvider({ children }) {
  const [leftSidebarIsHidden, setLeftSidebarIsHidden] = useState(true)

  return (
    <SidebarContext.Provider value={{ leftSidebarIsHidden, setLeftSidebarIsHidden }}>
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error('useSidebar debe usarse dentro de SidebarProvider')
  }
  return context
}
